import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { NavigationItemComponent } from '../../components/navigation-item/navigation-item.component';

@Component({
	selector: 'vex-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NavigationItemComponent],
})
export class NavigationComponent {
	private navigationService = inject(NavigationService);

	items = this.navigationService.items;
}
